module.exports = __webpack_public_path__ + "static/media/vidoeAndSound.5997700a.svg";